<script>
import { get } from 'lodash'
import RootHeader from './headers'
import PatienMobile from './headers/mobile/patient'

export default {
  name: 'app',
  computed: {
    pageFull () {
      return get(this.$route.meta, 'full', false)
    }
  },
  components: {
    RootHeader,
    PatienMobile
  }
}
</script>

<template lang="pug">
  small#app
    root-header
    patien-mobile
    router-view
</template>



// WEBPACK FOOTER //
// src/layout/app.vue